import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useBillModel } from "./billModel";
import { IBillDetail } from "../../../bill/BillTypes";
import { useDetailModel } from "../detailModel";
import { billStatusRender, ioFlagRender } from "@/types/FmsRender";
import { TradeTypeEnum } from "@/types/FmsEnums";
import useGlobalModel from "@/model/globalModel";



export function BillDataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys
    } = useBillModel();

    const {
        payMethodLabels,
    } = useDetailModel()

    const { user: { shopCode } } = useGlobalModel()

    const columns: ColumnsType<IBillDetail> = [
        {
            align: "center",
            title: '序号',
            render: (v, r, i) => i + 1
        },
        // {
        //     align: "center",
        //     title: '分支',
        //     dataIndex: 'branch',
        // },
        {
            align: "center",
            title: '交易方向',
            dataIndex: 'shopCode',
            render: (v, r) => v === shopCode ? '调入' : '调出'
        },
        {
            align: "center",
            title: '调拨单号',
            dataIndex: 'code',
        },

        {
            align: "center",
            title: '单据金额',
            dataIndex: 'aggregateAmount',
        },
        // {
        //     align: "center",
        //     title: '调入账户',
        //     dataIndex: '',
        // },
        {
            align: "center",
            title: '调入门店',
            dataIndex: 'shopName',
        },
        {
            align: "center",
            title: '调入实体',
            dataIndex: 'bentityName',
        },
        // {
        //     align: "center",
        //     title: '调出账户',
        //     dataIndex: '',
        // },
        {
            align: "center",
            title: '调出门店',
            dataIndex: 'outShopName',
        },
        {
            align: "center",
            title: '调出实体',
            dataIndex: 'outBentityName',
        },
        {
            align: "center",
            title: '调拨类型',
            dataIndex: 'transferTypeName',
        },
        {
            align: "center",
            title: '账单状态',
            dataIndex: 'status',
            render: billStatusRender
        },
        // {
        //     align: "center",
        //     title: '结款状态',
        //     dataIndex: 'payStatus',
        //     render: billStatusRender
        // },
        // {
        //     align: "center",
        //     title: '支付类型',
        //     dataIndex: 'payType',
        //     render: v => payMethodLabels[v]
        // },
        {
            align: "center",
            title: '记账日期',
            dataIndex: 'createTime',
        },
        {
            align: "center",
            title: '核销人',
            dataIndex: 'writeoffUser',
        },
        {
            align: "center",
            title: '核销日期',
            dataIndex: 'writeoffTime',
        },
        // {
        //     align: "center",
        //     title: '单据编码',
        //     dataIndex: 'code',
        // },
        {
            align: "center",
            title: '业务员',
            dataIndex: 'createUser',
        },
        {
            align: "center",
            title: '备注',
            dataIndex: 'note',
        },
    ];


    return (
        <Table
            // rowSelection={{
            //     type: "radio",
            //     onChange: (selectedRowKeys: React.Key[], selectedRows: IBillDetail[]) => {
            //         setSelectedRowKeys(selectedRowKeys);
            //     },
            //     selectedRowKeys
            // }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                showTotal: (total: number) => `共${total}条`,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            // onRow={record => {
            //     return {
            //         onClick: event => {
            //             if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.key) {
            //                 setSelectedRowKeys([]);
            //             } else {
            //                 setSelectedRowKeys([record.key]);
            //             }
            //         },
            //     };
            // }}
            scroll={{ x: 'max-content' }}
        />
    )
}
